import { Directive, ElementRef, Input, SecurityContext, Sanitizer, Renderer2, HostListener, NgModule, Injectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-auto-focus.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class AaclAutofocusDirective {
    /**
     * @param {?} _el
     */
    constructor(_el) {
        this._el = _el;
    }
    /**
     * @param {?} condition
     * @return {?}
     */
    set autofocus(condition) {
        this._autofocus = condition !== false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this._autofocus || typeof this._autofocus === 'undefined') {
            this._el.nativeElement.focus();
        }
    }
}
AaclAutofocusDirective.ɵfac = function AaclAutofocusDirective_Factory(t) { return new (t || AaclAutofocusDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AaclAutofocusDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AaclAutofocusDirective, selectors: [["", "aaclAutoFocus", ""]], inputs: { autofocus: "autofocus" } });
/** @nocollapse */
AaclAutofocusDirective.ctorParameters = () => [
    { type: ElementRef }
];
AaclAutofocusDirective.propDecorators = {
    autofocus: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclAutofocusDirective, [{
        type: Directive,
        args: [{
                selector: '[aaclAutoFocus]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { autofocus: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AaclAutofocusDirective.prototype._autofocus;
    /**
     * @type {?}
     * @private
     */
    AaclAutofocusDirective.prototype._el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-truncated-data-tooltip/aacl-truncated-data-tooltip.utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const isChanged = (/**
 * @param {?} propertyName
 * @param {?} changes
 * @param {?=} skipFirstChange
 * @return {?}
 */
(propertyName, changes, skipFirstChange = true) => (changes[propertyName] && (!changes[propertyName].isFirstChange() || !skipFirstChange) &&
    changes[propertyName].previousValue !== changes[propertyName].currentValue));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-truncated-data-tooltip/aacl-truncated-data-tooltip.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclTruncatedDataTooltipDirective {
    /**
     * @param {?} _sanitizer
     * @param {?} _renderer
     */
    constructor(_sanitizer, _renderer) {
        this._sanitizer = _sanitizer;
        this._renderer = _renderer;
        this._innerHTML = '(empty)';
        this._maxWidth = '200px';
        this._tooltipContainerClasses = [];
        this.OFFSET_X = 5;
        this.OFFSET_Y = 5;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (isChanged('aaclTooltipContent', changes) && this.aaclTruncatedDataTooltip) {
            this._innerHTML = this.aaclTooltipContent || '(empty)';
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._init();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._remove();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onMouseEnter(e) {
        if (this.aaclTruncatedDataTooltip) {
            this._create(e.clientY + this.OFFSET_Y, e.clientX + this.OFFSET_X);
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onMouseLeave(e) {
        this._remove();
    }
    /**
     * @private
     * @return {?}
     */
    _init() {
        if (this.aaclTooltipOptions) {
            this._maxWidth = this.aaclTooltipOptions.maxWidth || '200px';
            this._tooltipContainerClasses = this.aaclTooltipOptions.tooltipContainerClasses ? this.aaclTooltipOptions.tooltipContainerClasses : [];
        }
        if (this.aaclTruncatedDataTooltip) {
            this._innerHTML = this.aaclTooltipContent || '(empty)';
        }
    }
    /**
     * @private
     * @param {?} top
     * @param {?} left
     * @return {?}
     */
    _create(top, left) {
        this._remove();
        this._dom = this._renderer.createElement('div');
        this._renderer.addClass(this._dom, 'aacl-truncated-data-tooltip');
        this._renderer.setStyle(this._dom, 'max-width', this._maxWidth);
        if (this._tooltipContainerClasses && this._tooltipContainerClasses.length > 0) {
            this._tooltipContainerClasses.forEach((/**
             * @param {?} containerClass
             * @return {?}
             */
            (containerClass) => {
                this._renderer.addClass(this._dom, containerClass);
            }));
        }
        /** @type {?} */
        const content = this._sanitizer.sanitize(SecurityContext.HTML, this._innerHTML);
        this._dom.innerHTML = `${content}`;
        this._renderer.appendChild(document.body, this._dom);
        this._move(top, left);
    }
    /**
     * @private
     * @param {?} top
     * @param {?} left
     * @return {?}
     */
    _move(top, left) {
        /** @type {?} */
        const tipWidth = this._dom.offsetWidth;
        /** @type {?} */
        const tipHeight = this._dom.offsetHeight;
        /** @type {?} */
        const vpWidth = document.body.clientWidth;
        /** @type {?} */
        const vpHeight = document.body.clientHeight;
        if (left + tipWidth > vpWidth) {
            left = vpWidth - tipWidth;
        }
        if (top + tipHeight > vpHeight) {
            top = vpHeight - tipHeight;
        }
        this._renderer.setStyle(this._dom, 'top', `${top}px`);
        this._renderer.setStyle(this._dom, 'left', `${left}px`);
    }
    /**
     * @private
     * @return {?}
     */
    _remove() {
        if (this._dom) {
            this._renderer.removeChild(document.body, this._dom);
            this._dom = null;
        }
    }
}
AaclTruncatedDataTooltipDirective.ɵfac = function AaclTruncatedDataTooltipDirective_Factory(t) { return new (t || AaclTruncatedDataTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Sanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
AaclTruncatedDataTooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AaclTruncatedDataTooltipDirective, selectors: [["", "aaclTruncatedDataTooltip", ""]], hostBindings: function AaclTruncatedDataTooltipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function AaclTruncatedDataTooltipDirective_mouseenter_HostBindingHandler($event) { return ctx.onMouseEnter($event); })("mouseleave", function AaclTruncatedDataTooltipDirective_mouseleave_HostBindingHandler($event) { return ctx.onMouseLeave($event); });
    } }, inputs: { aaclTruncatedDataTooltip: "aaclTruncatedDataTooltip", aaclTooltipOptions: "aaclTooltipOptions", aaclTooltipContent: "aaclTooltipContent" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
AaclTruncatedDataTooltipDirective.ctorParameters = () => [
    { type: Sanitizer },
    { type: Renderer2 }
];
AaclTruncatedDataTooltipDirective.propDecorators = {
    aaclTruncatedDataTooltip: [{ type: Input }],
    aaclTooltipOptions: [{ type: Input }],
    aaclTooltipContent: [{ type: Input }],
    onMouseEnter: [{ type: HostListener, args: ['mouseenter', ['$event'],] }],
    onMouseLeave: [{ type: HostListener, args: ['mouseleave', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclTruncatedDataTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[aaclTruncatedDataTooltip]'
            }]
    }], function () { return [{ type: ɵngcc0.Sanitizer }, { type: ɵngcc0.Renderer2 }]; }, { 
    /**
     * @param {?} e
     * @return {?}
     */
    onMouseEnter: [{
            type: HostListener,
            args: ['mouseenter', ['$event']]
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave', ['$event']]
        }], aaclTruncatedDataTooltip: [{
            type: Input
        }], aaclTooltipOptions: [{
            type: Input
        }], aaclTooltipContent: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AaclTruncatedDataTooltipDirective.prototype.aaclTruncatedDataTooltip;
    /** @type {?} */
    AaclTruncatedDataTooltipDirective.prototype.aaclTooltipOptions;
    /** @type {?} */
    AaclTruncatedDataTooltipDirective.prototype.aaclTooltipContent;
    /**
     * @type {?}
     * @private
     */
    AaclTruncatedDataTooltipDirective.prototype._innerHTML;
    /**
     * @type {?}
     * @private
     */
    AaclTruncatedDataTooltipDirective.prototype._maxWidth;
    /**
     * @type {?}
     * @private
     */
    AaclTruncatedDataTooltipDirective.prototype._tooltipContainerClasses;
    /**
     * @type {?}
     * @private
     */
    AaclTruncatedDataTooltipDirective.prototype._dom;
    /**
     * @type {?}
     * @private
     */
    AaclTruncatedDataTooltipDirective.prototype.OFFSET_X;
    /**
     * @type {?}
     * @private
     */
    AaclTruncatedDataTooltipDirective.prototype.OFFSET_Y;
    /**
     * @type {?}
     * @private
     */
    AaclTruncatedDataTooltipDirective.prototype._sanitizer;
    /**
     * @type {?}
     * @private
     */
    AaclTruncatedDataTooltipDirective.prototype._renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-basic-utils.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclBasicUtilsModule {
}
AaclBasicUtilsModule.ɵfac = function AaclBasicUtilsModule_Factory(t) { return new (t || AaclBasicUtilsModule)(); };
AaclBasicUtilsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AaclBasicUtilsModule });
AaclBasicUtilsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclBasicUtilsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AaclAutofocusDirective,
                    AaclTruncatedDataTooltipDirective
                ],
                imports: [],
                exports: [
                    AaclAutofocusDirective,
                    AaclTruncatedDataTooltipDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AaclBasicUtilsModule, { declarations: [AaclAutofocusDirective, AaclTruncatedDataTooltipDirective], exports: [AaclAutofocusDirective, AaclTruncatedDataTooltipDirective] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-device-type.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclDeviceTypeService {
    /**
     * @return {?}
     */
    detectMobileDevice() {
        if (AaclDeviceTypeService._isMobileDevice == null) {
            AaclDeviceTypeService._isMobileDevice = !!navigator.userAgent.match(/iPad|iPhone|Android|Windows Phone|webOS/i);
        }
        return AaclDeviceTypeService._isMobileDevice;
    }
}
AaclDeviceTypeService.ɵfac = function AaclDeviceTypeService_Factory(t) { return new (t || AaclDeviceTypeService)(); };
AaclDeviceTypeService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AaclDeviceTypeService, factory: AaclDeviceTypeService.ɵfac });
AaclDeviceTypeService._isMobileDevice = null;
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclDeviceTypeService, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AaclDeviceTypeService._isMobileDevice;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-truncated-data-tooltip/aacl-truncated-data-tooltip.options.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAaclTruncatedDataTooltipOptions() { }
if (false) {
    /** @type {?|undefined} */
    IAaclTruncatedDataTooltipOptions.prototype.maxWidth;
    /** @type {?|undefined} */
    IAaclTruncatedDataTooltipOptions.prototype.tooltipContainerClasses;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: aacl-basic-utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AaclAutofocusDirective, AaclBasicUtilsModule, AaclDeviceTypeService, AaclTruncatedDataTooltipDirective };

